"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapModeLegend = void 0;
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const classnames_1 = require("../../util/classnames");
const map_line_1 = require("../topological.editor.map/map.line/map.line");
const map_point_1 = require("../topological.editor.map/map.point/map.point");
const map_mode_legend_style_1 = require("./map.mode.legend.style");
(0, theme_1.addStyles)(map_mode_legend_style_1.Style);
function lineIcon(color) {
    return (0, mithril_1.m)('div', { className: map_mode_legend_style_1.CSS.legendIconLine, style: `background-color: ${color}` });
}
function pointIcon(accuracy, selected = false) {
    return (0, mithril_1.m)('div', {
        className: (0, classnames_1.classNames)(map_point_1.TopologicalEditorPointCSS.container, map_point_1.poleMeasurementAccuracyTypes[accuracy], {
            [map_point_1.TopologicalEditorPointCSS.isSelected]: selected,
        }),
    });
}
const legendItems = [
    {
        icon: lineIcon((0, map_line_1.getSpanLineColor)('dropspan')),
        text: i18n_1.T.MAPMODE_LEGEND_DROPSPAN,
    },
    {
        icon: lineIcon((0, map_line_1.getSpanLineColor)('anchor')),
        text: i18n_1.T.MAPMODE_LEGEND_ANCHOR,
    },
    {
        icon: lineIcon((0, map_line_1.getSpanLineColor)('span')),
        text: i18n_1.T.MAPMODE_LEGEND_SPAN,
    },
    {
        icon: lineIcon((0, map_line_1.getSpanLineColor)('unknown')),
        text: i18n_1.T.MAPMODE_LEGEND_UNKNOWN,
    },
    {
        icon: (0, mithril_1.m)('div', { className: (0, classnames_1.classNames)(map_point_1.TopologicalEditorPointCSS.title, map_mode_legend_style_1.CSS.legendCollectionLabelOverride) }, 'abc'),
        text: i18n_1.T.MAPMODE_LEGEND_COLLECTION_LABEL,
    },
    {
        icon: pointIcon('rtk_fixed', true),
        text: i18n_1.T.MAPMODE_LEGEND_SELECTED_COLLECTION,
    },
    {
        icon: pointIcon('rtk_fixed'),
        text: i18n_1.T.MAPMODE_LEGEND_LOCATION_RTK_FIXED,
    },
    {
        icon: pointIcon('edited'),
        text: i18n_1.T.MAPMODE_LEGEND_LOCATION_REVIEWED,
    },
    {
        icon: pointIcon('rtk_float'),
        text: i18n_1.T.MAPMODE_LEGEND_LOCATION_RTK_FLOAT,
    },
    {
        icon: pointIcon('low'),
        text: i18n_1.T.MAPMODE_LEGEND_LOCATION_LOW_ACCURACY,
    },
];
exports.MapModeLegend = {
    view() {
        return (0, mithril_1.m)('div', { className: map_mode_legend_style_1.CSS.container }, legendItems.map((item) => (0, mithril_1.m)('div', { className: map_mode_legend_style_1.CSS.legendItem }, [
            (0, mithril_1.m)('div', { className: map_mode_legend_style_1.CSS.legendIcon }, item.icon),
            (0, mithril_1.m)('div', { className: map_mode_legend_style_1.CSS.legendText }, (0, i18n_1.Translate)(item.text)),
        ])));
    },
};
//# sourceMappingURL=map.mode.legend.js.map